import React from 'react';
import NavigationHeader from '../components/navigationHeader';
import BreadCrumb from '../components/breadCrumb';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { CopyRightsFooter } from '../components/copyrights';
import ErrorHandler from '../components/error_500';
import * as d3 from 'd3';
import {postMixpanel} from '../mixpanel';
// import { browserHistory } from 'react-router';
import DrxReportFullScreen from "./components/dqReportFullScreen"
import {logoutPageRedirect} from "../utils/common_utils";
import PipelinePerformance from "./components/pipeline_performance";
import Badge from 'react-bootstrap/Badge';

import {
    getPerformanceChartData,
    getModelErrTableData,
    setShowMoreData,
    convertModelDetails,
    getModelErrorsOfPerformanceCharts,
    getMLModelOptionsForGivenMapping,
    mapModelToDataSource,
    getModelPerfListViewTableData,
    setDQShowMoreData,
    getMonitorCompareViewTableData,
    getFeatureAccess,
    getModelNameMappedCharts, getTotalShowMoreDataPointsCount,
    extractDatasetInfoForMonitorListView,

} from "../utils/common_utils";
import { DQ_MONITOR_SECTIONS, IS_NONE_CHECK, IS_SAAS_EDITION } from "../utils/constant";
import { connect } from "react-redux";
import { getApi, postUIlogs} from "../utils/event_handling";
import MonitorDQTabs from "./monitorDQTabs";
import MonitorMPTabs from "./monitorMPTabs";
import MonitorERTabs from "./monitorERTabs";
import MonitorDQPTabs from  "./monitorDQPTabs";
// import ModelBias from "./modelBias";
import _ from "lodash";
// import {PIPELINE_USER} from "../utils/constant";

 import store from "../redux/store";
import Load from '../components/loadAction';
 import {
     preFetchMonitorPreview,
     preFetchMonitorInfo,
      preFetchMonitorModelInfo,
      preFetchModelDetails,
     preFetchMetrics,
      getLastProfilingTime,
      preFetchMonitorListViewData
 } from "../utils/monitorDataFetch";

 import {
      prefetchModelABData,
 } from "../utils/dataFetch";

import {
    setDataSource,
    setMlDataSource,
    addRelationship,
    addMetaData,
    addMLModelMapping,
    setMLModel,
    addDataSource,
    addInfo,
    addLastProfilingTime,
    setEndDate,
    setStartDate,
    addDiscoveryStatus,
    addProcessingStatus,
    addEnvironment,
    addEnvironmentDataSourceMapping,
    addDataSourceDataSetMapping,
    addDataSetAttributeMapping,
    setAttribute,
    setDataSet,
    addMonitorPreview,
    addPerformancePreview,
    addCompletenessDataSetInfo,
    addCompletenessAttributeInfo,
    addTimelinessDataSetInfo,
    addTimelinessAttributeInfo,
    addConformityDataSetInfo,
    addConformityAttributeInfo,
    addAccuracyDataSetInfo,
    addAccuracyAttributeInfo,
    addDriftDataSetInfo,
    addDriftAttributeInfo,
    addConsistencyDataSetInfo,
    addConsistencyAttributeInfo,
    addMLDataSetInfo,
    addMLAttributeInfo,
    addMLModel,
    addModelPerformance,
    addModelDetails,
    addFollowAttributes,
    addMonitorDQListViewData,
    addMetrics,
    addUniquenessDataSetInfo,
    addUniquenessAttributeInfo,
    addRecencyPreview,
    prefetchMonitorState,
    noIntegration,
    storeMetadataDetails,
    mappedDatasetInfo,
    listViewTableData,
    setModelABDataToList
} from "../redux/actions";

import {
        getMetaDatas,
} from "../utils/monitorEventHandling"

const dq_chartview_metrics =  [{"label":"Data Drift","value":"drift"},{"label":"Data Completeness","value":"completeness"},{"label":"Data Uniqueness","value":"uniqueness"},{"label":"Data Timeliness","value":"timeliness"},{"label":"Data Accuracy","value":"accuracy"},{"label":"Data Conformity","value":"conformity"},{"label":"Data Consistency","value":"consistency"}]
const colors = ['#FA4616', '#00c7d4', '#ffc700', '#4d9ff9', '#915cff', '#ff6c7c'];
class Monitor extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.pre_load = true
        // let tab = "modelPerf";
        let tab = "dq";
        let childTab = null;
        let additionalInfoFromParam = null;

        let metricsList = this.props.monitorModule.metrics;
        let mapConsistencykey = metricsList.filter(x=> x.data_set_id === null && x.mas_name === "Data Consistency" && x.metric_type === "default" )
        let mapConsistencyvalue = metricsList.filter(x=> x.data_set_id !== null && x.mas_name === "Data Consistency" && x.metric_type === "default" )
        const result = {};
        mapConsistencykey.forEach(item => {
            result[item.metrics_id] = mapConsistencyvalue
                .filter(value => value.metric_name === item.metric_name)
                .map(value => value.metrics_id);
        });

        // Following line is for removing additional parameters from url
        // browserHistory.replace("/monitor");
        if (this.props.activeTabKey !== undefined) {
            tab = this.props.activeTabKey
        }

        if (this.props.innerTab !== undefined) {
            childTab = this.props.innerTab
        }
        localStorage.setItem("additionalInfoFromParam", "");
        if (this.props.additionalInfo !== undefined) {
            additionalInfoFromParam = this.props.additionalInfo
            localStorage.setItem("additionalInfoFromParam", additionalInfoFromParam);
        }


        if (this.props.route !== undefined && this.props.route.activeTabKey !== undefined &&
            this.props.route.activeTabKey !== null) {
            tab = this.props.route.activeTabKey;
        }

         let hideMonitorModelTab = true;
         let featureAccess = getFeatureAccess()
         if (!IS_NONE_CHECK.includes(featureAccess)) {
            const monitorModel = featureAccess["models"];
            hideMonitorModelTab = monitorModel === false;
         }


        let enableDQReportsTab = false;
        if (!IS_NONE_CHECK.includes(featureAccess)) {
            const DQReportsTab = featureAccess["dq-reports"];
            enableDQReportsTab = DQReportsTab === true;
        }

        tab = hideMonitorModelTab ? "dq" : tab;
        this.hideContent = this.hideContent.bind(this);
        this.getModelErrTableData = getModelErrTableData.bind(this);
        this.getModelErrorsOfPerformanceCharts = getModelErrorsOfPerformanceCharts.bind(this);
        this.setShowMoreData = setShowMoreData.bind(this);
        this.postUIlogs = postUIlogs.bind(this);
        this.changeTab = this.changeTab.bind(this);
        this.getPerformanceChartData = getPerformanceChartData.bind(this);
        this.getData = this.getData.bind(this);
        this.getApi = getApi.bind(this);
        this.drxReport = this.drxReport.bind(this);
        this.closedrxReportfullscreen = this.closedrxReportfullscreen.bind(this);

        this.convertModelDetails = convertModelDetails.bind(this);
        this.getMetaDatas = getMetaDatas.bind(this);
        this.setCustomFilterValues = this.setCustomFilterValues.bind(this);
         this.preFetchMonitorInfo = preFetchMonitorInfo.bind(this);
         this.preFetchMonitorListViewData = preFetchMonitorListViewData.bind(this);
        // this.getMappedMetadatas = getMappedMetadatas.bind(this);
        // this.getFollowAttributes = getFollowAttributes.bind(this);
        let reduxPerformanceResult = this.props.monitorModule.mlModelPerformanceInfo;
        let resultList = Object.keys(reduxPerformanceResult).map(x => reduxPerformanceResult[x]);

        const metaDataMapping = this.props.dataModule.metaData;
        const mappedDatasetInfo = extractDatasetInfoForMonitorListView(metaDataMapping);



        let timelinessShowMore = setDQShowMoreData(this.props.monitorModule.timelinessDataSetInfo,
            this.props.monitorModule.timelinessAttributeInfo, this.props.dataModule,
            null, DQ_MONITOR_SECTIONS.TIMELINESS);

        const propsDataModule = this.props.dataModule;


        let fullModelInfo = []

        let modelPerformanceData = []
        let mlModelDetails = []
        let datasetLevelInfo = []
        let attributeLevelInfo = []
        let errorCharts = []
        let showMoreData = []
        let completeFullscreenDataModelPerf = []
        let tableData = []
        let tableDataModelPerfListView = []
        let mlModelMapping = []
        let modelDataSourceDetails = []

        // ----- AB testing -> Model Performance Compare View table data preparation begins ----

        let modelABData = []
        let modelInfoMap = []
        let mappedChartData = []
        let mpCompareViewData = []
        // eslint-disable-next-line
        let mpCompareViewTableData = []
        // eslint-disable-next-line
        let mpCompareViewDetailedChartData = []
        // ----- AB testing -> Model Performance Compare View table data preparation over ------
        let currDataCount = []

        if (hideMonitorModelTab === false) {
            fullModelInfo = this.props.monitorModule.mlModelDetails;
            modelPerformanceData = this.getPerformanceChartData(resultList,
                this.props.monitorModule.mlModelMapping, true, mappedDatasetInfo, fullModelInfo);

            for (let chartData of modelPerformanceData) {
                chartData["errorChart"] = true;
                if (chartData["drift_patterns"] === undefined) {
                    chartData["drift_patterns"] = [];
                }
            }

            mlModelDetails = this.convertModelDetails(fullModelInfo);
            datasetLevelInfo = _.cloneDeep(this.props.monitorModule.mlModelDataSetInfo)
            attributeLevelInfo = _.cloneDeep(this.props.monitorModule.mlModelAttributeInfo)
            errorCharts = this.getModelErrorsOfPerformanceCharts(modelPerformanceData);

            showMoreData = this.setShowMoreData(datasetLevelInfo, attributeLevelInfo,
                mlModelDetails, errorCharts);


            tableData = this.getModelErrTableData(this.props.monitorModule, this.props.dataModule, modelPerformanceData, showMoreData);

            completeFullscreenDataModelPerf = getPerformanceChartData(resultList, mlModelMapping, false, mappedDatasetInfo, fullModelInfo);

            modelDataSourceDetails = mapModelToDataSource(fullModelInfo);

            tableDataModelPerfListView = getModelPerfListViewTableData(completeFullscreenDataModelPerf,
                modelDataSourceDetails,
                propsDataModule,
                mlModelMapping, fullModelInfo);

            mlModelMapping = this.props.monitorModule.mlModelMapping;

            // ----- AB testing -> Model Performance Compare View table data preparation begins ----

            modelABData = this.props.dataModule.modelABData;
            modelInfoMap = this.props.dataModule.modelInfoMap;
            mappedChartData = getModelNameMappedCharts(completeFullscreenDataModelPerf);
            mpCompareViewData = getMonitorCompareViewTableData(modelABData, modelInfoMap,
                mappedChartData, showMoreData);
            mpCompareViewTableData = mpCompareViewData["tableRows"];
            mpCompareViewDetailedChartData = mpCompareViewData["abDetailedChartData"];

            // ----- AB testing -> Model Performance Compare View table data preparation over ------
            // eslint-disable-next-line
            currDataCount = getTotalShowMoreDataPointsCount(showMoreData);

        }



        this.state = {
            isDrxReportFullscreenMode:false,
            enableDQReportsTab: enableDQReportsTab,
            errorOccurred: false,
            // showLoader: false,
            closeAction: false,
            hideMonitorModelTab: hideMonitorModelTab,
            activeTabKey: tab,
            innerTab: childTab,
            mappedDatasetInfo: mappedDatasetInfo,
            additionalInfoFromParam: additionalInfoFromParam,
            modelPerformanceDataModelErr: modelPerformanceData,
            integrationsMap: null,
            mapConsistencyResult:result,
            showMoreDataCount: currDataCount,
            tableData: tableData["finalData"],
            attributeOptions: tableData["attributeOptions"],
            showMoreData: showMoreData,
            mlModelOptions: getMLModelOptionsForGivenMapping(mlModelDetails),
            tableUpdated: false,
            timelinessShowMore: timelinessShowMore,

            /*Following are values are for model performance tab*/
            fullModelInfo: fullModelInfo,
            propsDataModule: propsDataModule,
            completeFullscreenDataModelPerf: completeFullscreenDataModelPerf,
            tableDataModelPerfListView: tableDataModelPerfListView,
            pre_load: true,
            // monitorDQListView:{},

            // Advance Filter
            filterData:[],
            showLoader:true,
            metaData:{},
            follow_attributes:{},
            integrationMapping:{},
            default_filter_data:{},
            inProgress: null,
            noDataFound:null,
            search_text:"",
            selectedEnv:null,
            integration_details:[]
        }
        this.getMetaDatas();
    }

    setCustomFilterValues(pmdata) {
        this.setState({default_filter_data:pmdata})
    }

    preFetch() {
         let teamID = localStorage.getItem('team_id')
         let tenantData = { "tenant_id": teamID };


          if (IS_SAAS_EDITION && !this.props.monitorModule.lastProfilingTime){
             getLastProfilingTime(tenantData, this.props.addLastProfilingTime, this.props.setStartDate, this.props.setEndDate,);
         }

        //    Monitor Prefetch
        // Prefetch happens for every Integrations
        // Gets the result and iterate for all integrations
         if (IS_SAAS_EDITION && !this.props.monitorModule.preFetchMonitorListViewData) {
             this.preFetchMonitorListViewData(teamID, this.props.addMonitorDQListViewData);
         }


        // Monitor Prefetch.
        // Single api call : /model_performance/results/info
         if (IS_SAAS_EDITION && !this.props.monitorModule.preFetchMonitorPreview) {
         preFetchMonitorPreview(tenantData, this.props.addMonitorPreview, this.props.addPerformancePreview,
             this.props.addModelPerformance);
         }


         if (IS_SAAS_EDITION) {
            //  for (const key of Object.keys(this.props.dataModule.integrations)) {
                //  if (!(key in this.props.monitorModule.fetchInfo && this.props.monitorModule.fetchInfo[key])) {
         this.preFetchMonitorInfo(
             tenantData, this.props.addCompletenessDataSetInfo, this.props.addCompletenessAttributeInfo,
             this.props.addTimelinessDataSetInfo, this.props.addTimelinessAttributeInfo,
             this.props.addAccuracyDataSetInfo, this.props.addAccuracyAttributeInfo,
             this.props.addConformityDataSetInfo, this.props.addConformityAttributeInfo,
             this.props.addConsistencyDataSetInfo, this.props.addConsistencyAttributeInfo,
             this.props.addDriftDataSetInfo, this.props.addDriftAttributeInfo, this.props.addMLDataSetInfo,
             this.props.addMLAttributeInfo, this.props.addMonitorPreview, this.props.addUniquenessDataSetInfo,
             this.props.addUniquenessAttributeInfo, this.props.addRecencyPreview,
             this.props.prefetchMonitorState, this.props.setDataSource
         );
                //  }
            //  }
         }
        //    Monitor Prefetch
        // Prefetch happens for every Integrations
        // Gets the result and iterate for all integrations
        // }
        // // Monitor Model Prefetch : model/map
        // // store the value in redux
         if (IS_SAAS_EDITION && !this.props.monitorModule.preFetchMonitorModelInfo) {
             preFetchMonitorModelInfo(
                 teamID, this.props.addMLModelMapping,
                 this.props.addMLDataSetInfo, this.props.addMLAttributeInfo,
                 this.props.addMLModel, this.props.setMLModel
             );
         }

        // // ML Monitor prefetch : ml-models
        // // Profile ML filter and ML tab
         if (IS_SAAS_EDITION && !this.props.monitorModule.preFetchModelDetails) {
             preFetchModelDetails(teamID, this.props.addModelDetails);
         }

        // custom Metrics Prefetch used in custom metric page
        // Fetch and Store
         if (IS_SAAS_EDITION && this.props.monitorModule.preFetchMetrics) {
             preFetchMetrics(teamID, this.props.addMetrics);
         }


        // // Monitor Model Prefetch used in configure and monitor : model_ab_data
         if (IS_SAAS_EDITION && !this.props.dataModule.prefetchModelABData) { // Fetch Model AB configuration list
             prefetchModelABData(tenantData, setModelABDataToList, store);
         }


    }



    componentDidMount() {
        let logoutPage = logoutPageRedirect()
        if (logoutPage) {
            return ''
        }

        this.preFetch()
        this.getData();
        this.getApi("integrations")
    }

    componentDidUpdate(prevProps) {
        let hideMonitorModelTab = true;
        let featureAccess = getFeatureAccess()


        if (!IS_NONE_CHECK.includes(featureAccess)) {
            const monitorModel = featureAccess["models"];
            hideMonitorModelTab = monitorModel === false;
        }
        if (hideMonitorModelTab === false) {

            if ((this.state.pre_load === false && this.props.dataModule !== prevProps.dataModule) || (this.props.monitorModule !== prevProps.monitorModule)) {
                const mlModelDetails = this.convertModelDetails(this.props.monitorModule.mlModelDetails);
                const datasetLevelInfo = _.cloneDeep(this.props.monitorModule.mlModelDataSetInfo)
                const attributeLevelInfo = _.cloneDeep(this.props.monitorModule.mlModelAttributeInfo)
                let errorCharts = this.getModelErrorsOfPerformanceCharts(this.state.modelPerformanceDataModelErr);
                const showMoreData = this.setShowMoreData(datasetLevelInfo, attributeLevelInfo, mlModelDetails, errorCharts);
                let tableData = getModelErrTableData(this.props.monitorModule, this.props.dataModule, this.state.modelPerformanceDataModelErr, showMoreData);

                this.setState({
                    tableData: tableData["finalData"],
                    attributeOptions: tableData["attributeOptions"],
                    tableUpdated: !this.state.tableUpdated,
                    mlModelOptions: getMLModelOptionsForGivenMapping(mlModelDetails),
                    showMoreData: showMoreData
                })
            }
        }
    }


    getData() {
        // this.getApi("integrations_profile");

    }

    componentDidCatch(error, info) {
        this.setState({ errorOccurred: true });
        this.postUIlogs(error, info);
    }

    componentWillUnmount() {
        document.body.classList.remove("overflow-hidden");
        d3.selectAll(".d3-tip").remove();
    }


    static getDerivedStateFromProps(props, state) {
        let prevFullModelInfo = state.fullModelInfo;
        let prevPropsDataModuleInfo = state.propsDataModule;
        const currPropsDataModule = props.dataModule;
        let finalObj = {}
        let hideMonitorModelTab = true;
        let featureAccess = getFeatureAccess()

        if (!IS_NONE_CHECK.includes(featureAccess)) {
            const monitorModel = featureAccess["models"];
            hideMonitorModelTab = monitorModel === false;
        }
        if (hideMonitorModelTab === false) {
            let reduxPerformanceResult = props.monitorModule.mlModelPerformanceInfo;
            const mlModelMapping = props.monitorModule.mlModelMapping;

            let resultList = Object.keys(reduxPerformanceResult).map(x => reduxPerformanceResult[x]);
            let fullModelInfo = props.monitorModule.mlModelDetails;
            let modelPerformanceData = getPerformanceChartData(resultList, mlModelMapping,
                true, state.mappedDatasetInfo, fullModelInfo);

            if (modelPerformanceData.length > state.modelPerformanceDataModelErr.length) {
                return {
                    modelPerformanceDataModelErr: modelPerformanceData
                }
            }

            /* Getting Model performance chart data */
            let completeFullscreenDataModelPerf = getPerformanceChartData(resultList, mlModelMapping, false, state.mappedDatasetInfo, fullModelInfo);
            let fullScreenDataChanged = (completeFullscreenDataModelPerf.length !==
                state.completeFullscreenDataModelPerf.length);

            /* Getting Model AB combined chart&table data preparation starts */
            const modelABDataProps = props.dataModule.modelABData;

            let modelABDataState = state.modelABData;
            if (modelABDataState === null || modelABDataState === undefined) {
                modelABDataState = [];
            }

            const currDataCount = getTotalShowMoreDataPointsCount(state.showMoreData);
            if (currDataCount !== state.showMoreDataCount) {
                fullScreenDataChanged = true;
            }

            if ((!IS_NONE_CHECK.includes(modelABDataProps) &&
                modelABDataProps.length !== modelABDataState.length) || fullScreenDataChanged) {
                // We will update this Model AB data when AB data is updated or
                // model performance chart data is changed
                const modelInfoMap = props.dataModule.modelInfoMap;
                const mappedChartData = getModelNameMappedCharts(completeFullscreenDataModelPerf);
                const mpCompareViewData = getMonitorCompareViewTableData(modelABDataProps, modelInfoMap,
                    mappedChartData, state.showMoreData);

                const mpCompareViewTableData = mpCompareViewData["tableRows"];
                const mpCompareViewDetailedChartData = mpCompareViewData["abDetailedChartData"];
                finalObj = {
                    modelABData: modelABDataProps,
                    showMoreDataCount: currDataCount,
                    mpCompareViewTableData: mpCompareViewTableData,
                    mpCompareViewDetailedChartData: mpCompareViewDetailedChartData,
                }
                // Return new values to state
            }
            /* ==== Model AB combined chart&table data preparation ends === */

            /* Getting data for Model performance - List view */
            let currFullModelInfo = props.monitorModule.mlModelDetails;

            const modelDataSourceDetails = mapModelToDataSource(currFullModelInfo);

            const modulePropsChanged = (Object.values(prevPropsDataModuleInfo) !==
                Object.values(currPropsDataModule));

            if (fullScreenDataChanged ||
                currFullModelInfo !== prevFullModelInfo ||
                modulePropsChanged || modelDataSourceDetails !== state.modelDataSourceDetails) {
                let tableDataModelPerfListView = getModelPerfListViewTableData(completeFullscreenDataModelPerf, modelDataSourceDetails,
                    currPropsDataModule, mlModelMapping, currFullModelInfo);
                const timelinessShowMore = setDQShowMoreData(props.monitorModule.timelinessDataSetInfo,
                    props.monitorModule.timelinessAttributeInfo, props.dataModule,
                    null, DQ_MONITOR_SECTIONS.TIMELINESS);
                finalObj = {
                    ...finalObj, ...{
                        fullModelInfo: currFullModelInfo,
                        tableDataModelPerfListView: _.cloneDeep(tableDataModelPerfListView),
                        propsDataModule: currPropsDataModule,
                        completeFullscreenDataModelPerf: completeFullscreenDataModelPerf,
                        mlModelOptions: getMLModelOptionsForGivenMapping(currFullModelInfo),
                        modelDataSourceDetails: modelDataSourceDetails,
                        modelPerfTableUpdated: !state.modelPerfTableUpdated,
                      //  showLoader: !state.monitorDQListView.apiFetchOver,
                        timelinessShowMore: timelinessShowMore
                    }
                }
            }
            else {

                const modulePropsChanged = (Object.values(prevPropsDataModuleInfo) !==
                Object.values(currPropsDataModule));

                if (modulePropsChanged ) {
                    const timelinessShowMore = setDQShowMoreData(props.monitorModule.timelinessDataSetInfo,
                        props.monitorModule.timelinessAttributeInfo, props.dataModule,
                        null, DQ_MONITOR_SECTIONS.TIMELINESS);
                    finalObj = {
                        ...finalObj, ...{
                            propsDataModule: currPropsDataModule,
                            // showLoader: !state.monitorDQListView.apiFetchOver,
                            // showLoader: !state.monitorDQListView.apiFetchOver,
                            timelinessShowMore: timelinessShowMore
                        }
                    }
                }

                if (Object.keys(finalObj).length > 0) {
                    return finalObj
                }
            }
            if (Object.keys(finalObj).length > 0) {
                return finalObj
            }
        }
        return null;
    }

    hideContent() {
        this.setState({
            closeAction: true,
        });
    }

    changeTab(tab) {
        postMixpanel("Monitor -> " + tab + " Tab Page")
        this.setState({ activeTabKey: tab });
    }
    drxReport(){
        document.body.classList.add("overflow-hidden");
        this.setState({
            isDrxReportFullscreenMode:true,
            DrxReportFullScreenClassKey:"show",
            DrxReportName:"testing"
        });
    }
    closedrxReportfullscreen(){
        document.body.classList.remove("overflow-hidden");
        this.setState({isDrxReportFullscreenMode:false,DrxReportFullScreenClassKey:""});
    }
    handleSearchChange = (event) => {
        let search_text = event.target.value.toLowerCase();
        this.setState({ search_text:search_text });

        let filteredEnv =  this.state.filterData["environmentOptions"].filter(env =>
          env.label.toLowerCase().includes(search_text)
        );

        this.setState({ filteredEnv:filteredEnv });
      };
      handleSelect = (env, index,latest_env_name) => {
        this.setState({
          selectedEnv: { ...env, color: env.label === latest_env_name ? '#4ca3ff' : colors[index % colors.length],},
        });
      };

    render() {
            let environment = this.state.filterData["environmentOptions"];

            const {
            selectedDataSource,
            environmentDataSourceMapping,
            environments
            } = this.props.dataModule;

            let latest_env_id = null;
            let latest_env_name = null;

            // derive environment from selected datasource
            if (selectedDataSource && environmentDataSourceMapping) {
            const envId = Object.keys(environmentDataSourceMapping).find(
                (id) =>
                environmentDataSourceMapping[id]
                    ?.map(Number)
                    .includes(Number(selectedDataSource))
            );

            if (envId) {
                latest_env_id = Number(envId);
                latest_env_name = environments[latest_env_id];
            }
            }

        let filteredDatasourceOptions = this.state.filterData && this.state.filterData["datasourceOptions"] && this.state.filterData["datasourceOptions"].filter(
            (datasource) => datasource.env_id === (this.state.selectedEnv !== null ? this.state.selectedEnv.value : latest_env_id)
        );
        let logoutPage = logoutPageRedirect()
        if (logoutPage) {
            return ''
        }
        let hidePipelineSourceTab = false;
        let featureAccess = getFeatureAccess()
        if (!IS_NONE_CHECK.includes(featureAccess)){
            const confPagePipelineData = featureAccess["pipeline"];
            if(confPagePipelineData!==undefined){
                hidePipelineSourceTab = confPagePipelineData === true;
            }
        }
        let firstDatasetUp = this.props.dataModule.tenantId === -1

        let defaultKey = this.state.hideMonitorModelTab ? "dq" : "modelPerf"
        return (
                <>
                {this.state.errorOccurred ? <ErrorHandler/> : ""}
                    <NavigationHeader page="monitor"
                     environment={environment}
                     latest_env_name={latest_env_name}
                     search_text={this.state.search_text}
                     handleSelect={this.handleSelect}
                     handleSearchChange={this.handleSearchChange}
                     selectedEnvName={this.state.selectedEnv?.label || latest_env_name || "Select Environment"}
                     filteredEnv={this.state.filteredEnv}
                     selectedEnv={this.state.selectedEnv} />
                    <main>
                        <BreadCrumb icon='chartArea' title='Monitor' />
                        <Tab.Container defaultActiveKey={defaultKey}
                            activeKey={this.state.activeTabKey}
                            onSelect={this.changeTab}>
                            <div className="qd-tab__header">
                                <div className="container-fluid">
                                    <div className="qd-tab__header-wrapper">
                                        <div className="qd-tab__header-menu">
                                            <Nav variant="tabs">
                                            <Nav.Item>
                                                    <Nav.Link eventKey="dqp" disabled={this.state.pre_load}>
                                                        <span className="qd-menu__link-text">Data Quality Performance</span>
                                                    </Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="dq" disabled={this.state.pre_load}>
                                                        <span className="qd-menu__link-text">Data Quality Errors</span>
                                                    </Nav.Link>
                                                </Nav.Item>
                                                {this.state.hideMonitorModelTab ? "" : <><Nav.Item>
                                                    <Nav.Link eventKey="modelPerf" disabled={this.state.pre_load}>
                                                        <span className="qd-menu__link-text">Model Performance</span>
                                                    </Nav.Link>
                                                </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="ml" disabled={this.state.pre_load}>
                                                            <span className="qd-menu__link-text">Model Errors</span>
                                                        </Nav.Link>
                                                    </Nav.Item></>
                                                }

                                                {hidePipelineSourceTab ?
                                            <>
                                            <Nav.Item>
                                            <Nav.Link eventKey="pipeline">
                                                    <span className="qd-menu__link-text">Pipeline Performance</span>
                                                </Nav.Link>
                                            </Nav.Item>
                                            {/* <Nav.Item>
                                                <Nav.Link eventKey="pipelineerror">
                                                    <span className="qd-menu__link-text">Pipeline Errors</span>
                                                </Nav.Link>
                                            </Nav.Item> */}
                                            </>
                                             : ""
                                            }
                                                                                            {this.state.enableDQReportsTab === true ?
                                            <Nav.Item>
                                                <Nav.Link onClick={this.drxReport}>
                                                    <span className="qd-menu__link-text">Monthly Report <sup><Badge>Beta</Badge></sup></span>
                                                </Nav.Link>
                                            </Nav.Item> : ""
                                            }
                                            </Nav>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="qd-container">
                                <div className="qd-body">
                                    <div className="qd-tab__content" id={this.state.activeTabKey + "Tab"}>
                                        {this.state.pre_load === true && this.state.filterData.length === 0 ? <Load /> :
                                            <Tab.Content>
                                                 <Tab.Pane mountOnEnter={true} unmountOnExit={true}
                                                    eventKey="dqp">
                                                    <MonitorDQPTabs
                                                        timelinessData={this.state.timelinessShowMore}
                                                        additionalInfoFromParamdp={this.state.additionalInfoFromParam}
                                                        firstDatasetUp={firstDatasetUp}
                                                        activeTabKey = {this.state.activeTabKey}
                                                        mapConsistency={this.state.mapConsistencyResult}
                                                        filterData={this.state.filterData}
                                                        metaData = {this.state.metaData}
                                                        mappedDatasetInfo = {this.state.mappedDatasetInfo}
                                                        follow_attributes={this.state.follow_attributes}
                                                        integrationMapping={this.state.integrationMapping}
                                                        default_filter_data={this.state.default_filter_data}
                                                        setCustomFilterValues={this.setCustomFilterValues}
                                                        inProgress={this.state.inProgress}
                                                        noDataFound={this.state.noDataFound}
                                                        filteredDatasourceOptions = {filteredDatasourceOptions}
                                                        selectedEnv = {this.state.selectedEnv !== null ? this.state.selectedEnv.value : latest_env_id}

                                                  />
                                                </Tab.Pane>
                                                <Tab.Pane mountOnEnter={true} unmountOnExit={true}
                                                    eventKey="dq">
                                                    {this.state.activeTabKey === 'dq' ?
                                                        <MonitorDQTabs
                                                            timelinessData={this.state.timelinessShowMore}
                                                            firstDatasetUp={firstDatasetUp}
                                                            activeTabKey = {this.state.activeTabKey}
                                                            filterData={this.state.filterData}
                                                            dqChartViewmetrics={dq_chartview_metrics}
                                                            mapConsistency={this.state.mapConsistencyResult}
                                                            tab={this.state.activeTabKey}
                                                            metaData = {this.state.metaData}
                                                            mappedDatasetInfo = {this.state.mappedDatasetInfo}
                                                            follow_attributes={this.state.follow_attributes}
                                                            integrationMapping={this.state.integrationMapping}
                                                            default_filter_data={this.state.default_filter_data}
                                                            setCustomFilterValues={this.setCustomFilterValues}
                                                            inProgress={this.state.inProgress}
                                                            noDataFound={this.state.noDataFound}
                                                            filteredDatasourceOptions = {filteredDatasourceOptions}
                                                            selectedEnv = {this.state.selectedEnv !== null ? this.state.selectedEnv.value : latest_env_id}

                                                            />
                                                        :
                                                        ''
                                                    }
                                                </Tab.Pane>
                                                {this.state.hideMonitorModelTab ? "" : <><Tab.Pane mountOnEnter={true} unmountOnExit={true}
                                                    eventKey="modelPerf">
                                                    <MonitorMPTabs
                                                        integrationsMap={this.state.integrationsMap}
                                                        innerTab={this.state.innerTab}
                                                        additionalInfoFromParam={this.state.additionalInfoFromParam}
                                                        tableDataListView={this.state.tableDataModelPerfListView}
                                                        completeFullscreenData={this.state.completeFullscreenDataModelPerf}
                                                        tableUpdated={this.state.modelPerfTableUpdated}
                                                        availableModelABData={this.state.modelABData}
                                                        mpCompareViewTableData={this.state.mpCompareViewTableData}
                                                        mpCompareViewDetailedChartData={this.state.mpCompareViewDetailedChartData}
                                                        firstDatasetUp={firstDatasetUp}
                                                        showLoader={this.state.pre_load}
                                                        modelDataSourceDetails={this.state.modelDataSourceDetails}
                                                        mlModelOptions={this.state.mlModelOptions}
                                                        modelErrShowMoreData={this.state.showMoreData}
                                                        attributeOptions={this.state.attributeOptions}
                                                        filterData={this.state.filterData}
                                                        default_filter_data={this.state.default_filter_data}
                                                        setCustomFilterValues={this.setCustomFilterValues}
                                                    />
                                                </Tab.Pane>
                                                    <Tab.Pane mountOnEnter={true} unmountOnExit={true}
                                                        eventKey="ml">
                                                        <MonitorERTabs
                                                            modelPerformanceData={this.state.modelPerformanceDataModelErr}
                                                            integrationsMap={this.state.integrationsMap}
                                                            tableData={this.state.tableData}
                                                            attributeOptions={this.state.attributeOptions}
                                                            firstDatasetUp={firstDatasetUp}
                                                            showLoader={this.state.pre_load}
                                                            timelinessShowMore={this.state.timelinessShowMore}
                                                            showMoreData={this.state.showMoreData}
                                                            tableUpdated={this.state.tableUpdated}
                                                            mlModelOptions={this.state.mlModelOptions}
                                                            filterData={this.state.filterData}
                                                            default_filter_data={this.state.default_filter_data}
                                                            setCustomFilterValues={this.setCustomFilterValues}

                                                        />
                                                    </Tab.Pane></>}

                                                <Tab.Pane mountOnEnter={true} unmountOnExit={true} eventKey="pipeline">
                                                <PipelinePerformance />
                                                </Tab.Pane>
                                                <Tab.Pane mountOnEnter={true} unmountOnExit={true}
                                                eventKey="pipelineerror">
                                                <PipelinePerformance />
                                            </Tab.Pane>
                                            </Tab.Content>
                                        }

                                    </div>
                            </div>
                        </div>
                    </Tab.Container>
                </main>
                <CopyRightsFooter/>
                {this.state.isDrxReportFullscreenMode ?
                    <DrxReportFullScreen fullScreenClassVal={this.state.DrxReportFullScreenClassKey}
                                            title="Title"
                                            key={this.state.selectedModelInFullScreen}
                                            closedrxReportfullscreen = {this.closedrxReportfullscreen}
                    >
                    </DrxReportFullScreen> : ''
                }
            </>
        );
    }
}

const mapStateToProps = state => {
    return state;
}

export default connect(mapStateToProps,
    {
        addMetaData,
        addMLModelMapping,
        setMLModel,
        setModelABDataToList,
        addEnvironment,
        addEnvironmentDataSourceMapping,
        addDataSourceDataSetMapping,
        addDataSetAttributeMapping,
        setDataSet,
        setAttribute,
        setDataSource,
        setMlDataSource,
        addRelationship,
        addDataSource,
        addInfo,
        addLastProfilingTime,
        setStartDate,
        setEndDate,
        addDiscoveryStatus,
        addProcessingStatus,
        addMonitorPreview,
        addPerformancePreview,
        addModelPerformance,
        addCompletenessDataSetInfo,
        addCompletenessAttributeInfo,
        addTimelinessDataSetInfo,
        addTimelinessAttributeInfo,
        addAccuracyDataSetInfo,
        addAccuracyAttributeInfo,
        addConformityDataSetInfo,
        addConformityAttributeInfo,
        addConsistencyDataSetInfo,
        addConsistencyAttributeInfo,
        addDriftDataSetInfo,
        addDriftAttributeInfo,
        addMLDataSetInfo,
        addMLAttributeInfo,
        addUniquenessDataSetInfo,
        addUniquenessAttributeInfo,
        addRecencyPreview,
        addMLModel,
        addModelDetails,
        addMetrics,
        addMonitorDQListViewData,
        prefetchMonitorState,
        noIntegration,
        mappedDatasetInfo,
        listViewTableData,
        addFollowAttributes,
        storeMetadataDetails
    }
)(Monitor);
